import Text from 'components/shared/Text'
import Link from 'components/shared/Link'
import { WinterBreakAttractionsAsideInfoWrapper } from './styles'
import { FormattedMessage } from 'react-intl'
import { WINTER_BREAK_ATTRACTIONS_SCHEDULE_LINK } from 'constants/links'

const WinterBreakAttractionsAsideInfo = () => (
    <WinterBreakAttractionsAsideInfoWrapper
        mt={[16, 74]}
        pl={[16, 20]}
        pr={[16, 20]}
        pt={[16, 24]}
        pb={[16, 24]}
    >
        <Text color="secondary_700" variant="heading4">
            <FormattedMessage
                id="promo.winter_break.aside_info_title"
                defaultMessage="Zimowe szaleństwo w Suntago!"
            />
        </Text>
        <Text variant="body" color="secondary_700" mt={[12, 24]} mb={[12, 24]}>
            <FormattedMessage
                id="promo.winter_break.aside_info_content"
                defaultMessage="Odkryj specjalną ofertę naszych zimowych atrakcji! <break></break>Tylko od 13 do 28 stycznia: zrelaksuj się, rozgrzej i korzystaj z zimy w pełni."
                values={{
                    break: (chunks: string[]) => <br />,
                }}
            />
        </Text>
        <Link
            variant="secondary"
            icon={null}
            target="_blank"
            path={WINTER_BREAK_ATTRACTIONS_SCHEDULE_LINK}
            isUnderlined
        >
            <Text color="secondary_500" variant="bodyStrong">
                <FormattedMessage
                    id="promo.winter_break.aside_info_cta"
                    defaultMessage="Sprawdź atrakcje"
                />
            </Text>
        </Link>
    </WinterBreakAttractionsAsideInfoWrapper>
)

export default WinterBreakAttractionsAsideInfo
